import { render, staticRenderFns } from "./material-compliance-report.vue?vue&type=template&id=54e413d6&scoped=true"
import script from "./material-compliance-report.vue?vue&type=script&setup=true&lang=js"
export * from "./material-compliance-report.vue?vue&type=script&setup=true&lang=js"
import style0 from "./material-compliance-report.vue?vue&type=style&index=0&id=54e413d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e413d6",
  null
  
)

export default component.exports